var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-sorting',{attrs:{"text":_vm.sortText,"is-ascending":_vm.isDirectionAscending,"sort-options":_vm.sortOptions,"sort-by":_vm.orderBy,"data-testid":"releases-sort"},on:{"sortDirectionChange":_vm.onDirectionChange,"sortByChange":_vm.onSortItemClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }